import { WeekSelectionWrapper } from './weeklyReports';
import { LOAD_LISTING_CONF } from '../loads/loadDataDelegate';


export const InvoicesReportForSelectedWeek = ({companyData, department}) => {
    const REPORT_LOAD_CONF = {
        ...LOAD_LISTING_CONF,
        columnProportions: "0.8fr 1fr 1fr 20% 0.8fr 1fr 1fr 0.8fr 0.7fr 0.8fr",
        columns: [
            {
                label: "Invoice Number", // TODO: Update label
                columnName: "invoiceNumber", // TODO: Update field name
                conditionalFormatting: ()=>{
                    return `& > * {font-weight:bold;}`
    
                },
                // Add valueGenerator or other props here if needed
            },
            ...LOAD_LISTING_CONF.columns.filter((_, index) => index !== 8)
        ]
    };
    return <WeekSelectionWrapper companyData={companyData} reportLink={'loads/invoicedLoadsForSelectedPeriodByDelDate'}  predefinedListConf={REPORT_LOAD_CONF} itemName={"Invoice"} department={department} />

}

// async function exportReportToXlsx(data, fileNamePart) {
//     try {
//         const cols = [
//         { header: "Invoice #",          value: r => r.invoiceNumber ?? "" },
//         { header: "Load #",             value: r => r.loadNumber ?? "" },
//         { header: "Amount for Invoice", value: r => Number(r.amountForInvoice) || 0 },
//         { header: "Truck #",            value: r => r.currentTruck?.truckNumber ?? "" },
//         { header: "Origin",             value: r => r.startCityState},
//         { header: "Destination",        value: r => r.endCityState},
//         { header: "Start Date", value: r => dateToString(r.startDate) ?? "" },
//         { header: "End Date",   value: r => dateToString(r.endDate) ?? "" },
//         { header: "Broker",     value: r => r.broker?.brokerageName ?? "" },
//         { header: "Status",     value: r => r.loadStatus ?? "" },
//         ];

//         // Build AOA
//         const aoa = [cols.map(c => c.header), ...data.map(r => cols.map(c => c.value(r)))];

//         // Worksheet
//         const ws = XLSX.utils.aoa_to_sheet(aoa);
//         ws["!cols"] = [
//         { wch: 12 }, { wch: 15 }, { wch: 16 }, { wch: 10 }, { wch: 20 }, { wch: 20 },
//         { wch: 10 }, { wch: 10 }, { wch: 35 }, { wch: 16 }
//         ];

//         // Numeric + format for "Amount for Invoice" (col B, index 1)
//         const lastRow = aoa.length;
//         for (let r = 2; r <= lastRow; r++) {
//         const ref = XLSX.utils.encode_cell({ r: r - 1, c: 2 }); // B{r}
//         if (ws[ref]) {
//             ws[ref].t = "n";
//             ws[ref].z = "#,##0.00";
//         }
//         }

//         // Workbook
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Report");

//         // Write -> Blob
//         const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//         const blob = new Blob([wbout], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         });

//         // Download
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `Invoices Report (${fileNamePart.replace(/\//g, '.')}).xlsx`;
//         document.body.appendChild(a); // helps Firefox
//         a.click();
//         document.body.removeChild(a);
//         // Give the browser a tick to start the download before revoking
//         await new Promise(res => setTimeout(res, 100));
//         URL.revokeObjectURL(url);

//         return true; // resolves true
//     } catch (err) {
//       console.error("Failed to export XLSX:", err);
//       // choose: either return false or rethrow
//       return false;
//     }
// }
// function dateToString (str) {
//     const date = new Date(str);
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');

//     return `${month}/${day}`;
// }
// (data)=>{
//     const cols = [
//         { header: "Load #",           value: r => r.loadNumber ?? "" },
//         { header: "Amount for Invoice", value: r => Number(r.amountForInvoice) || 0 },
//         { header: "Truck #",          value: r => r.currentTruck?.truckNumber ?? "" },
//         { header: "Origin",    value: r => {const stop = r.stops[0]?.address;
//             return stop ? `${stop.city}, ${stop.state}` : ""
//         }},
//         { header: "Destination",    value: r => {const stop = r.stops[r.stops.length-1]?.address;
//             return stop ? `${stop.city}, ${stop.state}` : "";
//         }},
        
//         { header: "Start Date",       value: r => dateToString(r.startDate) ?? "" },
//         { header: "End Date",         value: r => dateToString(r.endDate) ?? "" },
//         // Optional examples pulling from nested arrays:
//         { header: "Broker",           value: r => r.broker?.brokerageName ?? "" },
//         { header: "Status",           value: r => r.loadStatus ?? "" },
        
//     ];
    
//     // 2) Build AOA: first row = headers, then data rows
//     const aoa = [
//     cols.map(c => c.header),
//     ...data.map(r => cols.map(c => c.value(r))),
//     ];
    
//     // 3) Create the worksheet from AOA
//     const ws = XLSX.utils.aoa_to_sheet(aoa);
    
//     // 4) Optional: set column widths
//     ws["!cols"] = [{ wch: 12 }, { wch: 16 }, { wch: 10 }, { wch: 20 }, { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 35 }, { wch: 16 }];
    
//     // 5) Optional: make "Amount for Invoice" numeric with format (column index 1 = column B)
//     const lastRow = aoa.length; // includes header
//     for (let r = 2; r <= lastRow; r++) { // start at row 2 (after header)
//     const ref = XLSX.utils.encode_cell({ r: r - 1, c: 1 }); // B{r}
//     if (ws[ref]) {
//         ws[ref].t = "n";
//         ws[ref].z = "#,##0.00";
//     }
//     }
    
//     // 6) Continue with your existing code that appends the sheet and downloads:
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Report");
    
//     // (keep your download code as-is)
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `user-report-${new Date().toISOString().slice(0,10)}.xlsx`;
//     a.click();
//     URL.revokeObjectURL(url);
//     return true;
// }